import React from "react";
import {
  SEO,
  PageLayout,
  Section,
  AnimatedSelector,
  BackgroundImages,
  FishermanHeader,
  MarkdownContent,
  WebsiteComponentInteractions,
  OutboundLink,
  FadeReveal,
  InternalLink,
  ContinuousScrollV2,
  multipleComponentIterator,
  BasicCarousel,
  componentIterator,
  Image,
  Accordion,
  MultipleComponentIterator,
  SlideReveal,
  Location,
  Phone,
  Email,
  HoursOfOperation,
  WebsiteComponentInteraction,
  ReviewV2,
  CustomerReviewModal,
} from "@bluefin/components";
import { Button, Grid } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
  getComponentInteractions,
} from "../utils/utils";
import {
  createServiceCategorySlug,
  createLocationSlug,
} from "@bluefin/gatsby-plugin-fisherman-page-creator";

export default class IndexPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      bookingUrl,
      allFishermanBusinessMenuCategory,
      allFishermanBusinessLocation,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          title={fishermanBusinessWebsitePage.seoTitle}
          ogImage={fishermanBusinessWebsitePage.seoOgImage}
          ogUrl={"https://www.indigobeauty.com/"}
        />
        <PageLayout hero={false} subfooter={false} className={"home-page"}>
          <Section className={"default-hero-section"}>
            <AnimatedSelector
              targetSelector={
                ".image.background::before, .image.background::after"
              }
              duration={1500}
              transitionType={"zoom"}
              transitionProps={{
                animating: { scale: 1 },
                preAnimating: { scale: 1.4 },
                serverSide: { scale: 1.4 },
              }}
              easing={"cubic-bezier(0,1,0.99,1)"}
              runPolicy={"RUN_ONCE_EVERY_VISIT"}
              animationKey={"home-hero-animation"}
            >
              <BackgroundImages
                images={getComponentFiles({
                  components: fishermanBusinessWebsitePage.components,
                  componentName: "HeroElement",
                })}
                carouselProps={{
                  leftArrowIcon: "arrow-left",
                  rightArrowIcon: "arrow-right",
                }}
                imageProps={{ loadStrategy: "eager" }}
              >
                <div className={"content-container"}>
                  <FishermanHeader
                    as={"h1"}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "home_hero_header",
                      defaultValue: "Enhancing Your Natural Beauty",
                    })}
                  />
                  <MarkdownContent
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "home_hero_description",
                    })}
                  />
                  <WebsiteComponentInteractions
                    ctas={getComponentInteractions({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "home_hero_description",
                    })}
                    alignment={"center"}
                    fallback={
                      <React.Fragment>
                        <Button
                          primary={true}
                          as={OutboundLink}
                          to={bookingUrl.url}
                          event={{
                            category: "Booking",
                            action: "Schedule Appointment Intent",
                          }}
                          content={bookingUrl.title}
                        />
                      </React.Fragment>
                    }
                  />
                </div>
              </BackgroundImages>
            </AnimatedSelector>
          </Section>
          <Section className={"about-section"}>
            <Grid stackable={true}>
              <Grid.Column width={8}>
                <FadeReveal duration={1250} triggerOnce={true} delay={0}>
                  <div>
                    <FishermanHeader
                      as={"h2"}
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_header",
                        defaultValue: "About Us",
                      })}
                    />
                    <MarkdownContent
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_description",
                      })}
                    />
                    <WebsiteComponentInteractions
                      ctas={getComponentInteractions({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_description",
                      })}
                      fallback={
                        <React.Fragment>
                          <Button
                            primary={true}
                            to={"/about/"}
                            as={InternalLink}
                            content={getComponentContentNodeContent({
                              components:
                                fishermanBusinessWebsitePage.components,
                              componentId:
                                "about_section_see_more_about_button",
                              defaultValue: "About Us",
                            })}
                            event={{ category: "About", action: "View About" }}
                          />
                        </React.Fragment>
                      }
                    />
                  </div>
                </FadeReveal>
              </Grid.Column>
              <Grid.Column width={8}>
                <FadeReveal duration={1250} triggerOnce={true} delay={450}>
                  <div>
                    <FishermanHeader
                      as={"h2"}
                      className={"highlighted"}
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_highlight_header",
                        defaultValue: "Top color, blonding, and facials",
                      })}
                    />
                  </div>
                </FadeReveal>
              </Grid.Column>
            </Grid>
          </Section>
          <Section className={"services-section"}>
            <ContinuousScrollV2
              multiplier={4}
              animationDurationSeconds={22}
              sizePatterns={[
                { width: "auto", height: 50, alignment: "middle" },
              ]}
              deviceSettings={{
                mobile: { elementWidth: "auto", gap: "0" },
                tablet: { elementWidth: "auto", gap: "0" },
                desktop: { elementWidth: "auto", gap: "0" },
              }}
              items={multipleComponentIterator({
                iterator: allFishermanBusinessMenuCategory.nodes,
                components: [
                  {
                    component: <ContinuousScrollV2.Item />,
                    propMap: { key: "_id" },
                    children: [
                      {
                        component: (
                          <Button
                            event={{
                              category: "Services",
                              action: "View Category Details",
                            }}
                            as={InternalLink}
                          />
                        ),
                        propMap: {
                          "event.label": "name",
                          to: createServiceCategorySlug,
                          content: "name",
                        },
                      },
                    ],
                  },
                ],
              })}
            />
            <FishermanHeader
              as={"h2"}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_header",
                defaultValue: "Our Services",
              })}
            />
            <MarkdownContent
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_description",
              })}
            />
            <WebsiteComponentInteractions
              alignment={"right"}
              ctas={getComponentInteractions({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_description",
              })}
              fallback={
                <React.Fragment>
                  <Button
                    primary={true}
                    event={{
                      category: "Services",
                      action: "View All Services",
                    }}
                    as={InternalLink}
                    to={"/services/"}
                  >
                    <span
                      children={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "services_section_see_all_services_button",
                        defaultValue: "See All",
                      })}
                    />
                  </Button>
                  <Button
                    primary={true}
                    as={OutboundLink}
                    to={bookingUrl.url}
                    event={{
                      category: "Booking",
                      action: "Schedule Appointment Intent",
                    }}
                    content={bookingUrl.title}
                  />
                </React.Fragment>
              }
            />
            <Grid stackable={true}>
              <Grid.Column width={8}>
                <BasicCarousel
                  size={1}
                  slide={true}
                  displayIndicators={false}
                  displayPlayPauseButton={false}
                  autoScroll={false}
                  leftArrowIcon={"arrow-left"}
                  rightArrowIcon={"arrow-right"}
                  mobile={{ size: 1 }}
                  items={componentIterator({
                    iterator: getComponentFiles({
                      components: fishermanBusinessWebsitePage.components,
                      componentIdentifier: "services_section_images",
                    }),
                    component: <Image background={true} />,
                    propMap: { src: "__all__" },
                  })}
                />
              </Grid.Column>
              <Grid.Column width={8}>
                <Accordion exclusive={true}>
                  <MultipleComponentIterator
                    iterator={allFishermanBusinessMenuCategory.nodes}
                    limit={6}
                    components={[
                      {
                        component: <React.Fragment />,
                        propMap: { key: "_id" },
                        children: [
                          {
                            component: (
                              <Accordion.Title
                                activeIcon={"minus"}
                                inactiveIcon={"plus"}
                              />
                            ),
                            propMap: { index: "__itemIndex__" },
                            children: [
                              {
                                component: (
                                  <SlideReveal
                                    fade={true}
                                    direction={"right"}
                                    firstAnimation={{ direction: "up" }}
                                  />
                                ),
                                children: [
                                  {
                                    component: <FishermanHeader as={"h3"} />,
                                    children: [
                                      {
                                        component: <span />,
                                        propMap: { children: "name" },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            component: <Accordion.Content />,
                            propMap: { index: "__itemIndex__" },
                            children: [
                              {
                                component: <MarkdownContent />,
                                propMap: { content: "description" },
                              },
                              {
                                component: (
                                  <Button
                                    content={"Options & Pricing >"}
                                    event={{
                                      category: "Services",
                                      action: "View Category Details",
                                    }}
                                    as={InternalLink}
                                  />
                                ),
                                propMap: {
                                  "event.label": "name",
                                  to: createServiceCategorySlug,
                                },
                              },
                            ],
                          },
                        ],
                      },
                    ]}
                  />
                </Accordion>
              </Grid.Column>
            </Grid>
          </Section>
          <Section className={"book-now-section"}>
            <Image
              background={true}
              src={getComponentFiles({
                components: fishermanBusinessWebsitePage.components,
                componentIdentifier: "book_now_section_background_image",
                numToSelect: 1,
              })}
            >
              <FishermanHeader
                as={"h2"}
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "book_now_section_header",
                  defaultValue: "Book Your Appointment",
                })}
              />
              <MarkdownContent
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "book_now_section_description",
                  defaultValue: "",
                })}
              />
              <WebsiteComponentInteractions
                ctas={getComponentInteractions({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "book_now_section_description",
                })}
                alignment={"center"}
                fallback={
                  <React.Fragment>
                    <Button
                      primary={true}
                      as={OutboundLink}
                      to={bookingUrl.url}
                      event={{
                        category: "Booking",
                        action: "Schedule Appointment Intent",
                      }}
                      content={bookingUrl.title}
                    />
                  </React.Fragment>
                }
              />
            </Image>
          </Section>
          <Section className={"locations-section"}>
            <FishermanHeader
              as={"h2"}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "locations_section_header",
                defaultValue: "Our Beautiful Locations",
              })}
            />
            <MarkdownContent
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "locations_section_description",
              })}
            />
            <WebsiteComponentInteractions
              ctas={getComponentInteractions({
                components: fishermanBusinessWebsitePage.components,
                componentId: "locations_section_description",
              })}
            />
            <Grid stackable={true}>
              <Grid.Column width={8}>
                <Accordion exclusive={true} defaultActiveIndexes={[0]}>
                  <MultipleComponentIterator
                    iterator={allFishermanBusinessLocation.nodes}
                    components={[
                      {
                        component: <React.Fragment />,
                        propMap: { key: "_id" },
                        children: [
                          {
                            component: (
                              <Accordion.Title
                                activeIcon={"minus"}
                                inactiveIcon={"plus"}
                              />
                            ),
                            propMap: { index: "__itemIndex__" },
                            children: [
                              {
                                component: (
                                  <SlideReveal
                                    fade={true}
                                    direction={"right"}
                                    firstAnimation={{ direction: "up" }}
                                  />
                                ),
                                children: [
                                  {
                                    component: <FishermanHeader as={"h3"} />,
                                    propMap: { content: "name" },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            component: <Accordion.Content />,
                            propMap: { index: "__itemIndex__" },
                            children: [
                              {
                                component: <div />,
                                children: [
                                  {
                                    component: (
                                      <div className={"information"} />
                                    ),
                                    children: [
                                      {
                                        component: <Location inline={true} />,
                                        propMap: {
                                          "address.street": "street",
                                          "address.city": "city",
                                          "address.state": "state",
                                          "address.zip": "zipCode",
                                        },
                                      },
                                      {
                                        component: <Phone />,
                                        propMap: { phone: "phoneNumber" },
                                      },
                                      {
                                        component: <Email />,
                                        propMap: { email: "email" },
                                      },
                                      {
                                        component: (
                                          <HoursOfOperation
                                            displayOption={"dailyWithPopup"}
                                            displayOpenClosedStatus={true}
                                            enhancedLabels={{
                                              openingSoon: "Opening soon",
                                              open: "Open now",
                                            }}
                                          />
                                        ),
                                        propMap: {
                                          hours: "hours",
                                          timezone: "timezone",
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    component: <div className={"ctas"} />,
                                    children: [
                                      {
                                        component: (
                                          <MultipleComponentIterator
                                            components={[
                                              {
                                                component: (
                                                  <WebsiteComponentInteraction
                                                    event={{
                                                      category: "Locations",
                                                      action:
                                                        "Location Interaction",
                                                    }}
                                                  />
                                                ),
                                                propMap: {
                                                  interaction: "__all__",
                                                },
                                              },
                                            ]}
                                          />
                                        ),
                                        propMap: { iterator: "interactions" },
                                      },
                                    ],
                                  },
                                ],
                              },
                              {
                                component: (
                                  <InternalLink
                                    className={"location-details"}
                                    label={"Location Details >"}
                                    event={{
                                      category: "Locations",
                                      action: "View Location Details",
                                    }}
                                  />
                                ),
                                propMap: {
                                  key: "_id",
                                  "event.label": "name",
                                  to: createLocationSlug,
                                },
                              },
                            ],
                          },
                        ],
                      },
                    ]}
                  />
                </Accordion>
                <div className={"ctas-container"}>
                  <Button
                    primary={true}
                    as={InternalLink}
                    to={"/locations/"}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "locations_section_see_all_locations_button",
                      defaultValue: "Discover Our Locations",
                    })}
                    event={{ category: "Locations", action: "View Locations" }}
                  />
                </div>
              </Grid.Column>
              <Grid.Column width={8}>
                <BasicCarousel
                  size={1}
                  slide={true}
                  displayIndicators={false}
                  displayPlayPauseButton={false}
                  autoScroll={false}
                  leftArrowIcon={"arrow-left"}
                  rightArrowIcon={"arrow-right"}
                  mobile={{ size: 1 }}
                  items={componentIterator({
                    iterator: getComponentFiles({
                      components: fishermanBusinessWebsitePage.components,
                      componentIdentifier: "locations_section_images",
                    }),
                    component: <Image background={true} />,
                    propMap: { src: "__all__" },
                  })}
                />
              </Grid.Column>
            </Grid>
          </Section>
          <div
            className={"elfsight-app-58c35794-caa9-4b2c-86e0-619a39ec138c"}
            data-elfsight-app-lazy={true}
          />
          <Section className={"reviews-section"}>
            <Image
              background={true}
              src={getComponentFiles({
                components: fishermanBusinessWebsitePage.components,
                componentIdentifier: "reviews_section_background_image",
                numToSelect: 1,
              })}
            >
              <FishermanHeader
                as={"h2"}
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "reviews_section_header",
                  defaultValue: "What Our Clients Say",
                })}
              />
              <BasicCarousel
                size={1}
                displayIndicators={true}
                stepSize={1}
                autoScroll={false}
                leftArrowIcon={"arrow-left"}
                rightArrowIcon={"arrow-right"}
                displayPlayPauseButton={false}
                slide={true}
                items={multipleComponentIterator({
                  iterator: fishermanBusiness.reviews,
                  components: [
                    {
                      component: <ReviewV2 />,
                      propMap: { key: "_id" },
                      children: [
                        {
                          component: <ReviewV2.Text charLimit={440} />,
                          propMap: { text: "text" },
                        },
                        {
                          component: <ReviewV2.Line />,
                          children: [
                            {
                              component: <ReviewV2.Rating />,
                              propMap: { rating: "rating" },
                            },
                            {
                              component: <ReviewV2.RatingLabel />,
                              propMap: { rating: "rating" },
                            },
                          ],
                        },
                        {
                          component: <ReviewV2.Line />,
                          children: [
                            {
                              component: <ReviewV2.Author />,
                              propMap: { author: "author" },
                            },
                            {
                              component: <ReviewV2.Source />,
                              propMap: { source: "source", link: "link" },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                })}
              />
              <CustomerReviewModal
                businessId={fishermanBusiness._id}
                locations={allFishermanBusinessLocation.nodes}
                businessType={fishermanBusiness.type}
                triggerButtonProps={{ secondary: true }}
                buttonText={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "reviews_section_submit_review_button",
                  defaultValue: "Submit Review",
                })}
              />
            </Image>
          </Section>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      reviews {
        _id
        author
        text
        source
        rating
        link
      }
      _id
      type
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Home" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        contentNodes {
          content
        }
        interactions {
          _id
          order
          behaviorType
          displayType
          enabled
          label
          style
          url
          role
        }
      }
      seoTitle
      seoOgImage {
        url
        alt
        type
      }
    }
    bookingUrl: fishermanBusinessWebsitePage(
      title: { regex: "/Book Now|Make An Appointment/" }
      pageType: { eq: "External" }
    ) {
      url
      title
    }
    allFishermanBusinessMenuCategory(
      sort: { fields: [isFeatured, order], order: [DESC, ASC] }
    ) {
      nodes {
        name
        _id
        description
        items
      }
    }
    allFishermanBusinessLocation {
      nodes {
        _id
        street
        city
        state
        zipCode
        name
        phoneNumber
        email
        hours {
          open
          close
          day
          label
        }
        timezone
        interactions {
          _id
          behaviorType
          displayType
          enabled
          label
          style
          url
          role
        }
        primaryLocation
      }
    }
  }
`;
